import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

/**
 * Componente per proteggere route che richiedono autenticazione
 * @param children - Componenti da renderizzare se autenticato
 * @param requiredRoles - Ruoli richiesti per accedere (opzionale)
 */
export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  children,
  requiredRoles,
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();

  // Mostra loading mentre verifica autenticazione
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <div>Caricamento...</div>
      </div>
    );
  }

  // Se non autenticato, redirect a login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Se specificati ruoli richiesti, verifica
  if (requiredRoles && requiredRoles.length > 0 && user) {
    const hasRequiredRole = requiredRoles.some(
      role => user.role.toString() === role
    );

    if (!hasRequiredRole) {
      // Non ha il ruolo richiesto - redirect a dashboard
      return <Navigate to="/dashboard" replace />;
    }
  }

  // Utente autenticato e con ruolo corretto
  return <>{children}</>;
};

PrivateRoute.displayName = 'PrivateRoute';
